import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMoneroComponent } from './simple-icons-monero.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMoneroComponent ],
    exports:      [ SimpleIconsMoneroComponent ],
    bootstrap:    []
})
export class SimpleIconsMoneroModule {}
